module.exports = __webpack_public_path__ + "static/img/kw.6b292996.svg";